export { default } from './ReadinessDetail';
